<div id="skills" class="container">
  <div class="skills container">
    <h2 data-aos="fade-right" class="text-white">Mes Compétences </h2>
    <h4 data-aos="fade-left" class="text-white">Web & Language</h4>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">HTML</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 80%" data-progress="70%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">Css</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 60%" data-progress="60%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">JavaScript</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 70%" data-progress="70%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">Php</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 64%" data-progress="70%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">Java</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 75%" data-progress="70%"></span>
      </div>
    </div>
    <h4 data-aos="flip-down" class="text-white">Base de données</h4>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">Oracle</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 73%" data-progress="70%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">Pl/Sql</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 58%" data-progress="70%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">MySql</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 70%" data-progress="70%"></span>
      </div>
    </div>
    <h4 data-aos-duration="2000" data-aos="flip-down" class="text-white">Data Science And AI</h4>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">Python</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 59%" data-progress="50%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">R</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 50%" data-progress="50%"></span>
      </div>
    </div>
    <h4 data-aos-duration="2000" data-aos="flip-down" class="text-white">Développement Backend</h4>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">Laravel</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 70%" data-progress="50%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">Spring|Spring Boot</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 66%" data-progress="50%"></span>
      </div>
    </div>
    <div data-aos-duration="2000" data-aos="fade-down-right" class="skill-box">
      <div class="skill-name">NestJs</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 30%" data-progress="50%"></span>
      </div>
    </div>
    <h4 data-aos-duration="2000" data-aos="flip-down" class="text-white">Développement FrontEnd</h4>
    <div data-aos-duration="2000" data-aos="fade-down-left" class="skill-box">
      <div class="skill-name">Angular</div>
      <div class="skill-progress">
        <span [ngStyle]="{'background-color':colorSelected}" style="width: 60%" data-progress="50%"></span>
      </div>
    </div>
  </div>
</div>
<!--<swiper [config]="config" #usefulSwiper style="padding: 70px;">-->
<!--  <div class="swiper-wrapper">-->
<!--    <div class="swiper-slide" *ngFor="let slide of slideData">-->
<!--      <img [src]="slide.url" [alt]="slide.alt" ]/>-->
<!--      {{slide.alt}}-->
<!--    </div>-->
<!--  </div>-->
<!--</swiper>-->